import React from "react";
import "./Hero.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCheck } from "@fortawesome/free-solid-svg-icons";
import AOS from "aos";
import "aos/dist/aos.css";
import { useEffect } from "react";

const Hero = () => {
  useEffect(() => {
    AOS.init({
      duration: 1000, 
      once: true, 
    });
  }, []);
  return (
    <>
      <section data-aos="fade" data-aos-duration="500" className="hero-section">
        <div className="hero-overlay-card" data-aos="fade" data-aos-duration="700">
          <h1>Livosol Dispatching</h1>
          <div className="hero-line"></div>
          <p>
            We provide one of the best freight dispatching services for
            owner-operators and small trucking companies in the US.
          </p>
        </div>
      </section>
      <section data-aos="fade-up" data-aos-duration="500" className="services py-5">
        <div className="container">
          <h1 className="ms-5">WHAT WE OFFER</h1>
          <div className="list-container row py-4">
            <div data-aos="fade-right" data-aos-duration="500" className="left-container col-md-6">
              <ul>
                <li>
                  {" "}
                  <FontAwesomeIcon
                    icon={faCheck}
                    color="red"
                    className="mx-3"
                  />{" "}
                  Dedicated Dispatchers
                </li>
                <li>
                  {" "}
                  <FontAwesomeIcon
                    icon={faCheck}
                    color="red"
                    className="mx-3"
                  />{" "}
                  Top Paying Loads
                </li>
                <li>
                  {" "}
                  <FontAwesomeIcon
                    icon={faCheck}
                    color="red"
                    className="mx-3"
                  />{" "}
                  Carrier Packet Setup
                </li>
                <li>
                  {" "}
                  <FontAwesomeIcon
                    icon={faCheck}
                    color="red"
                    className="mx-3"
                  />{" "}
                  Rate Negotiations
                </li>
                <li>
                  {" "}
                  <FontAwesomeIcon
                    icon={faCheck}
                    color="red"
                    className="mx-3"
                  />{" "}
                  Invoicing Paperwork
                </li>
              </ul>
            </div>
            <div data-aos="fade-left" data-aos-duration="500"  className="right-container col-md-6">
              <ul>
                <li>
                  {" "}
                  <FontAwesomeIcon
                    icon={faCheck}
                    color="red"
                    className="mx-3"
                  />{" "}
                  Handle Lumper/Detention
                </li>
                <li>
                  {" "}
                  <FontAwesomeIcon
                    icon={faCheck}
                    color="red"
                    className="mx-3"
                  />{" "}
                  No Forced Dispatch
                </li>
                <li>
                  {" "}
                  <FontAwesomeIcon
                    icon={faCheck}
                    color="red"
                    className="mx-3"
                  />{" "}
                  No Time-Bound Contract
                </li>
                <li>
                  {" "}
                  <FontAwesomeIcon
                    icon={faCheck}
                    color="red"
                    className="mx-3"
                  />{" "}
                  Route Planning
                </li>
                <li>
                  {" "}
                  <FontAwesomeIcon
                    icon={faCheck}
                    color="red"
                    className="mx-3"
                  />{" "}
                  Back-Office Support
                </li>
              </ul>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default Hero;
